const NS = 'WoolTimeriteBlock';
const CLS = 'woolTimeriteBlock';

let moment = require('moment');
let uuidv4 = require('uuid/v4');
let d3 = require('d3');

import { mediaQuery } from '../../../../global/js/wool/mediaQuery';
import { numberFormatter } from '../../../../global/js/wool/numberFormatter';
import file from '../../../../global/data/postcode_au.json';
import { toInteger } from 'lodash';
import {selectize} from '@selectize/selectize';

export class WoolTimeriteBlock {
	constructor(element, className = CLS) {
		this.element = element;
		this.$element = $(element);
		this.$error = this.$element.find(`.error`);
		this.$woolTimeriteBlockCharts = this.$element.find(`.woolTimeriteBlock-charts`);
		this.$bestTime = this.$element.find(`.best-time`);
		this.$calculate = this.$element.find(`.calculate`);
		this.$opportunity = this.$element.find(`.opportunity`);
		this.$diapause = this.$element.find(`.diapause`);
		this.$recovery = this.$element.find(`.recovery`);
		this.$inputPostcode = this.$element.find(`.inputPostcode`);
		this.$errorMsg = this.$element.find(`.errorMsg`);
		this.$loading  = this.$element.find(`#loading`);
		this.$printBtn = this.$element.find(`#printBtn`);
		this.$select = this.$element.find(`select`);
		this.$labelRedline = this.$element.find(`.label-redline`);
		this.$labelGreenline = this.$element.find(`.label-greenline`);
		this.$labelGreyBox = this.$element.find(`.label-greybox`);
		this.$learnMore = this.$element.find(`.learnMore`);
		this.$learnMoreBtn = this.$element.find(`.learnMoreBtn`);
		this.$bottomGraph = this.$element.find(`.bottom-graph`);
		this.$select.selectize({  valueField: 'postcodeLocality',
		labelField: 'postcodeLocality',
		searchField: 'postcodeLocality',
		options:file,
		create: false});
		this.setChartId();

		this.isDataEmpty = false;
		this.timeRitedata = {};
		this.margin = {
			top: 10,
			right: 30,
			bottom: 50,
			left: 90
		};
		this.file = file;
		this.mediaQuery = mediaQuery;
		this.numberFormatter = numberFormatter;
		this.heightRatio = 0.55;
		this.setButtonEvent();
		this.showBottomChart();

		this.$element.on(`${className}.update`, (e, datas) => {
			let data = datas.data;
			if(!_.isNil(data)) {
				this.isDataEmpty = false;
				this.data = data;
				this.initChart();
			}
			else {
				this.$errorMsg.html("No data available for this postcode.");
				this.$woolTimeriteBlockCharts.css('display','none');
				this.$loading.css('display','none');
				this.print = false;
			}
		});

		this.dotFocusRadius = 7;
		this.spray_date;
		this.sprayDatesArr = [];
		this.sprayDateInNum;

		this.printChart();
	}

	// Calculate btn pass the lat and log to API
	setButtonEvent() {
		$(this.$calculate).on('click', (event) => {
			this.$woolTimeriteBlockCharts.css('display','block');
			this.$labelGreenline.css('display','none');
			this.$labelRedline.css('display','none');
			this.$labelGreyBox.css('display','none');
			this.print = true; // Set print btn true(display) in when start calculate
			//var inputPostcode = $(this.$inputPostcode).val();
			var inputPostcode = $(this.$select).val();
			this.postcodeData = this.file;
			this.$errorMsg.html(" ");
			this.postcode = 0;
			this.lat = 0;
			this.lon = 0;
		  this.postcodeData.forEach((element) => {
			if(element.postcodeLocality === inputPostcode){
				this.postcode = element.postcode;
				this.lat = element.lat;
				this.lon = element.lon;
				this.api = "https://rlem-diapause-cdsy77yrna-uc.a.run.app/?verbose=true&lon="+this.lon+"&lat="+this.lat;
				return;
			}
		  });
		  if(!this.postcode || this.postcode == 0 || this.postcode > 9999){
				this.$errorMsg.html("Please enter the correct postcode");
				this.$woolTimeriteBlockCharts.css('display','none');
				this.print = false;
			}
		  $('.left_label').css('display','none');
		  $('h3').css('display','none');
		  $('.description').css('display','none');
		  this.$learnMore.css('display','none');
		  $(this.$loading).css('display','block');
		  		this.$bestTime.empty();
				this.$opportunity.empty();
				this.$diapause.empty();
				this.$recovery.empty();
				this.getChartDataFromApi();
		}); 
	}

	showBottomChart(){
		$(this.$learnMoreBtn).on('click', (event) => {
			if($(this.$bottomGraph).hasClass('isOpen')){
				$(this.$learnMore).removeClass('isOpen');
				$(this.$bottomGraph).removeClass('isOpen');
			}
			else{
				$(this.$learnMore).addClass('isOpen');
				$(this.$bottomGraph).addClass('isOpen');
			}
		});
	}

	// Retrieves the data from the API
	getChartDataFromApi() {
		let url = this.api;
		if(this.api) {
			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				success: (response) => {
					if(response && response.length > 0) {
						this.$element.trigger(`${CLS}.update`, {
							data: response
						});
					}
					else {
						this.$element.trigger(`${CLS}`, {
							data: null,
							isEmpty: true
						});
					}
					$('h3').css('display','block');
					$('.left_label').css('display','block');
					$('.description').css('display','block');
					this.$loading.css('display','none');
					if(this.print){
						this.$printBtn.css('display', 'block');
					}
					else{
						this.$printBtn.css('display', 'none');
					}
				},
				error: () => {
					this.$element.trigger(`${CLS}`, {
						data: null
					});					
				}
			});
		}
		else {
			console.error(`${NS}::Error`, 'API is not set.');
			this.$element.trigger(`${CLS}.update`, {
				data: null
			});
		}
	}

	getChartNodeOpportunity() {
		return d3.select(`[data-uuid="${this.opportunityId}"]`);
	}
	getChartNodeDiapauseId() {
		return d3.select(`[data-uuid="${this.diapauseId}"]`);
	}
	getChartNodeRecoveryId() {
		return d3.select(`[data-uuid="${this.recoveryId}"]`);
	}

	// Ensures that the chart contains a unique id
	setChartId() {
		this.opportunityId = uuidv4();
		this.diapauseId = uuidv4();
		this.recoveryId = uuidv4();
		this.$opportunity.attr('data-uuid', this.opportunityId);
		this.$diapause.attr('data-uuid', this.diapauseId);
		this.$recovery.attr('data-uuid', this.recoveryId);
	}

	// Initializes the chart by revealing it, drawing it and implementing an event that redraws it when the window resizes
	initChart() {
		let spray_dates_duplicate = []; // Array for all spray dates
		let spray_dates = []; // Array for all spray dates remove the duplicates
		this.sprayDatesArr = []; // copy spray_dates array to this.sprayDatesArr
		_.forEach(this.data, (datum) => {
			_.forEach(datum.sims, (value) => {
				_.forEach(value, (sprayDate) => {
					spray_dates_duplicate.push(sprayDate.spray_date);
				});
			});
		});
		spray_dates_duplicate.forEach(element => {
			if (!spray_dates.includes(element)) {
				spray_dates.push(element);
			}
		});
		this.sprayDatesArr = spray_dates;
		setTimeout(() => {
			this.sprayDateInNum = this.sprayDatesArr[this.getBestSprayDate()-1]; //get the spray date in number
			this.$diapause.css({ visibility: 'visible' });
			this.$opportunity.css({ visibility: 'visible' });
			this.$recovery.css({ visibility: 'visible' });
			this.bestTime();
			this.drawOpportunity();
			this.drawDiapause();
			this.drawRecovery();
		}, "500");

	}

	// Convert num to Julian day
	convertDate(date){
		const currentYear = new Date().getFullYear(); 
			// Create a date for January 1 of the current year 
			const startDate = new Date(currentYear, 0, 1); 
			// Calculate the date by adding the Julian day minus 1 (since we start counting from 1) 
			const resultDate = new Date(startDate.getTime() + (date - 1) * 24 * 60 * 60 * 1000); 
			const options = {
  				year: "numeric", month: "numeric", day: "numeric"
			};
			return resultDate.toLocaleDateString("en-GB", options);
	}

	// Display the your TIMERITE date
	bestTime(){
		var date;
		var timerite_date;
		var window_start_date;
		var start_date;
		var window_end_date;
		var end_date;
		const options = {
			year: "numeric", month: "numeric", day: "numeric"
		};
		date = new Date(this.data[0].timerite_date);
		window_start_date = new Date(this.data[0].window_start_date);
		window_end_date = new Date(this.data[0].window_end_date);
		timerite_date = date.toLocaleDateString("en-GB", options);
		start_date = window_start_date.toLocaleDateString("en-GB", options);
		end_date = window_end_date.toLocaleDateString("en-GB", options);
		this.$labelRedline.css("display", "block");
		this.$labelGreenline.css("display", "block");
		this.$labelGreyBox.css('display','block');
		this.$learnMore.css('display','block');
		this.$bestTime.append(`<h2>Your TIMERITE® Best spray date is `+timerite_date+`</h2> <h5>Your TIMERITE® Best window of opportunity is <strong>` + start_date + `</strong> to <strong>` + end_date + `</strong>.</h5>`);
	}

	//
	getBestSprayDate(){
		var spray_date = [];
		var maxDis = [];
		var newData =[];
		_.forEach(this.data[0].sims, (datas) => {
			spray_date.push(datas[0].spray_date);
			var maxDiArr = [];
			_.forEach(datas, (values) => {
				maxDiArr.push(values.Di);
			});
			maxDis.push(Math.max(...maxDiArr));
		});
		
		for(var i = 0; i < spray_date.length; i++){
			newData.push(200-maxDis[i]);
		}
		return newData.indexOf(Math.max(...newData))+1;
	}

	drawOpportunity(spray_date) {

		if(!spray_date){
			this.spray_date = this.getBestSprayDate();
		}
		else{
			this.spray_date = spray_date;
		}

		d3.select(`[data-uuid="${this.opportunityId}"]`).select('svg').remove(); // Removes the chart
		this.setChartDimensions();

		if(this.$tooltip && this.$tooltip.length > 0) {
			this.$tooltip.remove(); // Removes the tooltip
		}
		this.drawSvgOpportunity();
		this.drawTooltip();

		this.defineXAxesScales();
		this.defineYAxesScales();
		this.drawXAxes(1);
		this.drawYAxes(this.svgOpportunity);

		if(!this.isDataEmpty) {
			this.defineColors();
			this.drawPaths(1);
			this.drawPoints();
		}
	}

	drawDiapause(spray_date) {
		if(!spray_date){
			this.spray_date = this.getBestSprayDate();
		}
		else{
			this.spray_date = spray_date;
		}
		
		d3.select(`[data-uuid="${this.diapauseId}"]`).select('svg').remove(); // Removes the chart
		this.setChartDimensions();

		this.drawSvgDiapause();

		this.defineXAxesScales2();
		this.defineYAxesScales();
		this.drawXAxes(2);
		this.drawYAxes(this.svgDiapause);

		if(!this.isDataEmpty) {
			this.defineColors();
			this.drawPaths(2);
		}
	}

	drawRecovery(spray_date) {
		if(!spray_date){
			this.spray_date = this.getBestSprayDate();
		}
		else{
			this.spray_date = spray_date;
		}
		
		d3.select(`[data-uuid="${this.recoveryId}"]`).select('svg').remove(); // Removes the chart
		this.setChartDimensions();

		this.drawSvgRecovery();

		this.defineXAxesScales2();
		this.defineYAxesScales();
		this.drawXAxes(3);
		this.drawYAxes(this.svgRecovery);

		if(!this.isDataEmpty) {
			this.defineColors();
			this.drawPaths(3);
			this.drawLabels(3);
		}
	}

	drawTooltip() {
		this.tooltip = this.getChartNodeOpportunity()
			.append('div')
			.attr('class', `${CLS}-chart-tooltip`);
		this.$tooltip = this.$opportunity.find(`.opportunity .${CLS}-chart-tooltip`);
	}

	setChartDimensions() {
		this.width = $(this.element).width() - this.margin.left - this.margin.right;
		if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
			this.height = this.$element.width() * this.heightRatio;
		}
		else{
			this.height = (this.$element.width() * this.heightRatio)-300;
		}
	}

	drawSvgOpportunity() {
		this.svgOpportunity = d3.select(`[data-uuid="${this.opportunityId}"]`)
			.append('svg')
			.attr('width', this.width + this.margin.left + this.margin.right)
			.attr('height', this.height + this.margin.top + this.margin.bottom)
			.append('g')
			.attr('transform', `translate(${this.margin.left},${this.margin.top})`);
	}

	drawSvgDiapause() {
		this.svgDiapause = d3.select(`[data-uuid="${this.diapauseId}"]`)
			.append('svg')
			.attr('width', this.$diapause.width + this.margin.left + this.margin.right)
			.attr('height', this.height + this.margin.top + this.margin.bottom)
			.append('g')
			.attr('transform', `translate(${this.margin.left},${this.margin.top})`);
	}	

	drawSvgRecovery() {
		this.svgRecovery = d3.select(`[data-uuid="${this.recoveryId}"]`)
			.append('svg')
			.attr('width', this.$recovery.width + this.margin.left + this.margin.right)
			.attr('height', this.height + this.margin.top + this.margin.bottom)
			.append('g')
			.attr('transform', `translate(${this.margin.left},${this.margin.top})`);
	}

	//For opportunity Chart X Axis
	getXAxisBottomData() {
		let timeData = [];
		_.forEach(this.data[0].sims, (datum) => {
			timeData.push(datum[0].spray_date);
		});
		let dataDate = [];
		timeData.forEach(element => {
			dataDate.push(this.convertDate(element));
		});
		return dataDate;
	}

	//For diapause and Mite population recovery Charts
	getXAxisBottomData2() {
		let timeData = [];
		_.forEach(this.data, (datum) => {
			_.forEach(datum.sims, (value) => {
				_.forEach(value, (time) => {
					timeData.push(time.time);
				});
			});
		});
		let data = [];
		timeData.forEach(element => {
			if (!data.includes(element)) {
				data.push(element);
			}
		});
		let dataDate = [];
		data.forEach(element => {
			dataDate.push(this.convertDate(element));
		});
		return dataDate;
	}

	//For all charts
	getYAxisLeftData() {
		let data = [];
		for(var i=0; i<=100; i++){
			data.push(i);
		}
		return data;
	}

	//For opportunity Chart
	defineXAxesScales() {
		var data = this.getXAxisBottomData();
		this.xMinTickValue = data[0];
		this.xMaxTickValue = data[data.length - 1];

		if(this.xMinTickValue === this.xMaxTickValue) {
			this.xMaxTickValue = moment(this.xMinTickValue, 'DD/MM/YYYY').add(1, 'years').subtract(2, 'months').format('DD/MM/YYYY');
			data.push(this.xMaxTickValue);
		}

		this.xAxisBottom = d3.scaleTime()
			.range([0, this.width])
			.domain(d3.extent(data, (datum) => {
				return this.getMomentDate(datum).toDate();
			})).nice();
	}

	//For diapause and Mite population recovery Charts
	defineXAxesScales2() {
		var data = this.getXAxisBottomData2();
		this.xMinTickValue = data[0];
		this.xMaxTickValue = data[data.length - 1];

		if(this.xMinTickValue === this.xMaxTickValue) {
			this.xMaxTickValue = moment(this.xMinTickValue, 'DD/MM/YYYY').add(1, 'years').subtract(2, 'months').format('DD/MM/YYYY');
			data.push(this.xMaxTickValue);
		}

		if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
			this.xAxisBottom2 = d3.scaleTime()
			.range([0, this.width])
			.domain(d3.extent(data, (datum) => {
				return this.getMomentDate(datum).toDate();
			})).nice();
		}
		else{
			this.xAxisBottom2 = d3.scaleTime()
			.range([0, this.width/2-105])
			.domain(d3.extent(data, (datum) => {
				return this.getMomentDate(datum).toDate();
			})).nice();
		}
	}

	//For all charts
	defineYAxesScales() {
		let data = this.getYAxisLeftData();
		let yMinTickValue = _.minBy(data, (datum) => {
			return datum;
		});

		let yMaxTickValue = _.maxBy(data, (datum) => {
			return datum;
		});

		if(yMinTickValue !== yMaxTickValue) {
			let range = yMaxTickValue - yMinTickValue;
			this.yTickValue = this.getLinearTick(range);

			this.yMaxTickValue = Math.ceil((yMaxTickValue) / this.yTickValue) * this.yTickValue;
			this.yMinTickValue = Math.floor((yMinTickValue / this.yTickValue)) * this.yTickValue;
		}
		else {
			this.yMaxTickValue = Math.ceil(yMaxTickValue);
			this.yMinTickValue = Math.floor(yMinTickValue);
			this.yTickValue = _.floor(this.yMaxTickValue, (((this.yMaxTickValue + '').toString().length) * -1) + 1); // Rounds to the negative {x} sf.; // Rounds to the negative {x} sf.
			if(this.yTickValue !== 0) {
				this.yMaxTickValue *= 2.05;
				this.yMinTickValue = 0;
			}
			else {
				this.yMinTickValue = -1;
				this.yTickValue = 1;
				this.yMaxTickValue = 1;
			}
		}

		this.yAxisLeft = d3.scaleLinear()
			.range([this.height, 0])
			.domain([
				this.yMinTickValue,
				this.yMaxTickValue
			]).nice();
	}

	drawXAxes(num) {
		let tickOffset = 1;

		let xMinTickDate = moment(this.xMinTickValue, 'DD/MM/YYYY');
		let xMaxTickDate = moment(this.xMaxTickValue, 'DD/MM/YYYY');
		let duration = moment.duration(xMaxTickDate.diff(xMinTickDate));

		// Render x-axes text values
		if(num === 1){
			(() => {
				let outerIndex = 0;
				this.svgOpportunity.append('g')
					.attr('class', 'x-axis')
					.attr('transform', `translate(0,${this.height + tickOffset})`)
					.call(d3.axisBottom(this.xAxisBottom).ticks(d3.timeDay.every(1)).tickFormat((value, index) => {
						if(duration.asMonths() <= 12) {
							if(duration.asMonths() <= 2) {
								// Return weekly date format if months <= 2
								if(index % 7 === 0) {//check if the index(days) has whole weeks
									return moment(value).format('DD MMM YY');
								}
							}
							else {
								// Return every first day of the month
									return moment(value).format('DD MMM YY');
							}
						}
						else {
							// Return every first day of the month
							if(moment(value).date() === 1) {
								// Return {x} monthly value based on {x} yearly value
								if(outerIndex % (Math.floor(duration.asYears()) * 2) === 0) {
									outerIndex++;
									return moment(value).format('DD MMM YY');
								}
								outerIndex++;
							}
						}
						return '';
					}));
			})();
		}

		if(num === 2){
			(() => {
				let outerIndex = 0;
				this.svgDiapause.append('g')
					.attr('class', 'x-axis')
					.attr('transform', `translate(0,${this.height + tickOffset})`)
					.call(d3.axisBottom(this.xAxisBottom2).ticks(d3.timeDay.every(1)).tickFormat((value, index) => {
						if(duration.asMonths() <= 12) {
							if(duration.asMonths() <= 2) {
								// Return weekly date format if months <= 2
								if(index % 7 === 0) {//check if the index(days) has whole weeks
									return moment(value).format('DD MMM YY');
								}
							}
							else {
								// Return every first day of the month
								if(moment(value).date() === 1) {
									return moment(value).format('DD MMM YY');
								}
							}
						}
						else {
							// Return every first day of the month
							if(moment(value).date() === 1) {
								// Return {x} monthly value based on {x} yearly value
								if(outerIndex % (Math.floor(duration.asYears()) * 2) === 0) {
									outerIndex++;
									return moment(value).format('DD MMM YY');
								}
								outerIndex++;
							}
						}
						return '';
					}));
			})();
		}

		if(num === 3){
			(() => {
				let outerIndex = 0;
				this.svgRecovery.append('g')
					.attr('class', 'x-axis')
					.attr('transform', `translate(0,${this.height + tickOffset})`)
					.call(d3.axisBottom(this.xAxisBottom2).ticks(d3.timeDay.every(1)).tickFormat((value, index) => {
						if(duration.asMonths() <= 12) {
							if(duration.asMonths() <= 2) {
								// Return weekly date format if months <= 2
								if(index % 7 === 0) {//check if the index(days) has whole weeks
									return moment(value).format('DD MMM YY');
								}
							}
							else {
								// Return every first day of the month
								if(moment(value).date() === 1) {
									return moment(value).format('DD MMM YY');
								}
							}
						}
						else {
							// Return every first day of the month
							if(moment(value).date() === 1) {
								// Return {x} monthly value based on {x} yearly value
								if(outerIndex % (Math.floor(duration.asYears()) * 2) === 0) {
									outerIndex++;
									return moment(value).format('DD MMM YY');
								}
								outerIndex++;
							}
						}
						return '';
					}));
			})();
		}

		// Render lines
		(() => {
			let outerIndex = 0;
			this.getChartNodeOpportunity().select('.x-axis').selectAll('line').attr('y2', (value, index, nodes) => {
				if(duration.asMonths() <= 12) {
					if(duration.asMonths() <= 2) {
						// Return weekly tick when if months <= 2
						if(index % 7 === 0) { //check if the index(days) has whole weeks
							return 20; //the height of the vertical line of each month.
						}
					}
					else {
						// Return monthly tick value
						if(moment(value).date() === 1) {
							return 20;
						}
					}
				}
				else {
					if(moment(value).date() === 1) {
						// Return {x} monthly tick based on {x} yearly value
						if(outerIndex % (Math.floor(duration.asYears())) === 0) {
							return 20;
						}
						outerIndex++;
					}
				}
				return 8;
			});
			this.getChartNodeDiapauseId().select('.x-axis').selectAll('line').attr('y2', (value, index, nodes) => {
				if(duration.asMonths() <= 12) {
					if(duration.asMonths() <= 2) {
						// Return weekly tick when if months <= 2
						if(index % 7 === 0) {
							return 20;
						}
					}
					else {
						// Return monthly tick value
						if(moment(value).date() === 1) {
							return 20;
						}
					}
				}
				return 8;
			});
			this.getChartNodeRecoveryId().select('.x-axis').selectAll('line').attr('y2', (value, index, nodes) => {
				if(duration.asMonths() <= 12) {
					if(duration.asMonths() <= 2) {
						// Return weekly tick when if months <= 2
						if(index % 7 === 0) {
							return 20;
						}
					}
					else {
						// Return monthly tick value
						if(moment(value).date() === 1) {
							return 20;
						}
					}
				}
				return 8;
			});
		})();

		// Conceal x-axes text values for mobile devices
		(() => {
			let ticks = this.getChartNodeOpportunity().select('.x-axis').selectAll('text');
			let outerIndex = 0;
			ticks.each((value, index, nodes) => {
				nodes[index].style.visibility = 'hidden';
				if(duration.asMonths() <= 12) {
					if(duration.asMonths() <= 2) {
						if(duration.asMonths() <= 1) {
							if(index % 7 === 0) {
								nodes[index].style.visibility = 'visible';
							}
						}
						else {
							// Return forntlightly on mobile for excess of one month
							if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
								if(index % 14 === 0) {
									nodes[index].style.visibility = 'visible';
								}
							}
							else {
								if(index % 7 === 0) {
									nodes[index].style.visibility = 'visible';
								}
							}
						}
					}
					else {
						if(moment(value).date() === 1) {
							if(duration.asMonths() > 8) {
								// Returns every other month on mobile when months > 8
								if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
									if(outerIndex % 3 === 0) {
										nodes[index].style.visibility = 'visible';
									}
									outerIndex++;
								}
								else {
									if(outerIndex % 2 === 0) {
										nodes[index].style.visibility = 'visible';
									}
									outerIndex++;
								}
							}
							else if(duration.asMonths() > 4) {
								if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
									if(outerIndex % 2 === 0) {
										nodes[index].style.visibility = 'visible';
									}
									outerIndex++;
								}
								else {
									nodes[index].style.visibility = 'visible';
								}
							}
							else {
								nodes[index].style.visibility = 'visible';
							}
						}
					}
				}
				else {
					if(moment(value).date() === 1) {
						if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
							if(outerIndex % (Math.floor(duration.asYears()) * 4) === 0) {
								nodes[index].style.visibility = 'visible';
							}
						}
						else {
							if(outerIndex % (Math.floor(duration.asYears()) * 2) === 0) {
								nodes[index].style.visibility = 'visible';
							}
						}
						outerIndex++;
					}
				}
			});
		})();
	}

	drawYAxes(chartObj) {

		let data = this.getYAxisLeftData();
		let yMinTickValue = _.minBy(data, (datum) => {
			return datum;
		});

		let yMaxTickValue = _.maxBy(data, (datum) => {
			return datum;
		});

		chartObj.append('g')
		.attr('class', 'y-axis')
		.attr('transform', `translate(-25, 0)`)
		.call(d3.axisLeft(this.yAxisLeft).tickFormat((value, index) => {
			if(data.length > 1 && yMinTickValue !== yMaxTickValue) {
				// If mobile devices and the modulo by 4 is 1
				if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
					if(index % 4 === 1) {
						return this.numberFormatter.formatNumbersWithCommas(value);
					}
				}
				else {
					if(index % 2 === 1) {
						return this.numberFormatter.formatNumbersWithCommas(value);
					}
				}
				return '';
			}
			else {
				return this.numberFormatter.formatNumbersWithCommas(value);
			}
		}).tickSize(-8).tickPadding(12).tickValues(d3.range(this.yMinTickValue, this.yMaxTickValue, this.yTickValue)));

		this.getChartNodeOpportunity().select('.y-axis').selectAll('line').attr('x2', (value, index, nodes) => {
			if(data.length > 1 && yMinTickValue !== yMaxTickValue) {
				// If mobile devices and the modulo by 4 is 1
				if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
					if(index % 4 === 1) {
						return -20;
					}
				}
				else {
					if(index % 2 === 1) {
						return -20;
					}
				}
			}
			return -10;
		});
	}

	// Util method to format moment dates
	getMomentDate(date, format = 'DD/MM/YYYY') {
		return moment(date, format);
	}

	// Define Colors for the charts
	defineColors() {
		this.colors = [];
		_.forEach(this.data, () => {
			this.colors.push("#333", "#0c7fbb", "#77b559", "#de4443");
		});
	}

	drawPaths(num) {
		if(num === 1){
			var spray_date = [];
			var globalMaxDiArr = [];
			var maxDis = [];
			var globalMaxDi;
			var objData = [];
			var objDataShaded = [];
			var newData =[];
			var newDataShaded = [];
			_.forEach(this.data[0].sims, (datas) => {
				spray_date.push(datas[0].spray_date);
			});
			_.forEach(this.data[0].sims, (datas) => {
				var maxDiArr = [];
				_.forEach(datas, (values) => {
					maxDiArr.push(values.Di);
				});
				maxDis.push(Math.max(...maxDiArr));
			});
			
			_.forEach(this.data[0].sims, (datas) => {
				_.forEach(datas, (values) => {
					globalMaxDiArr.push(values.Di);
				});
			});
			globalMaxDi = Math.max(...globalMaxDiArr);
			for(var i = 0; i < spray_date.length; i++){
				var obj = {
					di: maxDis[i],
					spray_date: spray_date[i]
				};
				objData.push(obj);
			}
			newData.push(objData);

			_.forEach(newData[0], (datas) => {
				if((globalMaxDi-datas.di)/globalMaxDi * 100 > 88 ){
					objDataShaded.push(datas);
				}

			});
			newDataShaded.push(objDataShaded);


			var window_start_date;
			var start_date;
			var window_end_date;
			var end_date;

			window_start_date = new Date(this.data[0].window_start_date);
			window_end_date = new Date(this.data[0].window_end_date);
			start_date = window_start_date.toLocaleDateString("en-GB", options);
			end_date = window_end_date.toLocaleDateString("en-GB", options);


			let newDataShadedss = [];
			newDataShadedss[0] = [{spray_date:window_start_date},{spray_date:window_end_date}];
			_.forEach(newDataShadedss, (datas) => {
				this.svgOpportunity.append('path')
					.datum(datas)
					.attr("fill", "#dddddd")
					.attr('stroke', "#dddddd")
					.attr('d', d3.area()
						.x((innerDatum) => {
							return this.xAxisBottom(innerDatum.spray_date);
						})
						.y(this.height)
						.y1(0)
						
					);

			});

			_.forEach(newData, (datas, index) => {
				this.svgOpportunity.append('path')
					.datum(datas)
					.attr('class', 'plot-line')
					.attr('stroke', this.colors[index])
					.attr('d', d3.area()
						.x((innerDatum) => {
							return this.xAxisBottom(this.getMomentDate(this.convertDate(innerDatum.spray_date)).toDate());
						})
						.y((innerDatum) => {
							return this.yAxisLeft((globalMaxDi-innerDatum.di)/globalMaxDi * 100);
						})
						.curve(d3.curveCatmullRom.alpha(1))
					);
			});

			var date;
		const options = {
			year: "numeric", month: "numeric", day: "numeric"
		};
		date = new Date(this.data[0].timerite_date);

			this.svgOpportunity.append("line")
			.attr("x1", this.xAxisBottom(date))
			.attr("y1", 0)
			.attr("x2", this.xAxisBottom(date))
			.attr("y2", this.height)
			.style("stroke-width", 1)
			.style("stroke", "green")
			.style("fill", "none");


			this.svgOpportunity.append("line")
			.attr("x1", this.xAxisBottom(this.getMomentDate(this.convertDate(this.sprayDateInNum)).toDate()))
			.attr("y1", 0)
			.attr("x2", this.xAxisBottom(this.getMomentDate(this.convertDate(this.sprayDateInNum)).toDate()))
			.attr("y2", this.height)
			.style("stroke-width", 3)
			.style("stroke", "red")
			.style("fill", "none");
		}
		if(num === 2){
			var newData = [];
			_.forEach(this.data, () => {
				newData.push(this.data[0].sims[this.spray_date]);
			});
			_.forEach(newData, (datas, index) => {
				this.svgDiapause.append('path')
					.datum(datas)
					.attr('class', 'plot-line')
					.attr('stroke', this.colors[index])
					.attr('d', d3.area()
						.x((innerDatum) => {
							return this.xAxisBottom2(this.getMomentDate(this.convertDate(innerDatum.time)).toDate());
						})
						.y((innerDatum) => {
							return this.yAxisLeft(innerDatum.diapause_prop * 100);
						})
						.curve(d3.curveCatmullRom.alpha(1))
					);
			});
			this.svgDiapause.append("line")
			.attr("x1", this.xAxisBottom2(this.getMomentDate(this.convertDate(this.sprayDateInNum)).toDate()))
			.attr("y1", 0)
			.attr("x2", this.xAxisBottom2(this.getMomentDate(this.convertDate(this.sprayDateInNum)).toDate()))
			.attr("y2", this.height)
			.style("stroke-width", 2)
			.style("stroke", "red")
			.style("fill", "none");
		}
		if(num === 3){
			var tempData = [];
			var newData = [];
			_.forEach(this.data[0].sims[this.spray_date], (datas, index) => {
				tempData.push(datas);
			});
			_.forEach(tempData, (values) => {
				let total = values.M1 + values.M2 + values.M3 + values.M4 + values.M5 + values.Ew + values.Di;
				let time = values.time;
				let mites = values.M1 + values.M2 + values.M3 + values.M4 + values.M5;
				let winterEggs = values.Ew;
				let diapauseEggs = values.Di;
				var mitesObj = {
					time: time,
					winterEggs: winterEggs,
					mites: mites,
					diapauseEggs: diapauseEggs
				}
				newData.push(mitesObj);
			});
			if(this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.SM)) {
				this.populationWidth = this.width + 90;
				this.populationHeight = 210;
			}
			else {
				this.populationWidth = this.width/2-12;
				this.populationHeight = 305;
			}
			var stackGen = d3.stack().keys(["winterEggs", "mites", "diapauseEggs"]);
			var stackedSeries = stackGen(newData); 
			var xScale = d3.scaleTime()
			.domain([newData[0].time, newData[newData.length-1].time])
			.range([90, this.populationWidth]);
			var yScale = d3.scaleLinear()
			.domain([0, 210])
			.range([this.populationHeight, 0]);

			var colorScale = d3.scaleOrdinal()
			.domain(["winterEggs", "mites", "diapauseEggs"])
			.range(["#77b559", "#0c7fbb", "#de4443"]);

			var areaGen = d3.area()
			.x((d) => xScale(d.data.time))
			.y0((d) => yScale(d[0]))
			.y1((d) => yScale(d[1]));

			d3.select(`[data-uuid="${this.recoveryId}"] svg`)
			.selectAll(".areas")
			.data(stackedSeries)
			.join("path")
			.attr("d", areaGen)
			.attr("fill", (d) => colorScale(d.key))
			.style("opacity", "0.7");

			//draw green line for spray date
			this.svgRecovery.append("line")
			.attr("x1", this.xAxisBottom2(this.getMomentDate(this.convertDate(this.sprayDateInNum)).toDate()))
			.attr("y1", 0)
			.attr("x2", this.xAxisBottom2(this.getMomentDate(this.convertDate(this.sprayDateInNum)).toDate()))
			.attr("y2", this.height)
			.style("stroke-width", 2)
			.style("stroke", "red")
			.style("fill", "none");
		}
	}

	// For Window of opportunity
	drawPoints() {
			var spray_date = [];
			var globalMaxDiArr = [];
			var maxDis = [];
			var globalMaxDi;
			var objData = [];
			var newData =[];
			_.forEach(this.data[0].sims, (datas) => {
				spray_date.push(datas[0].spray_date);
				var maxDiArr = [];
				_.forEach(datas, (values) => {
					maxDiArr.push(values.Di);
					globalMaxDiArr.push(values.Di);
				});
				maxDis.push(Math.max(...maxDiArr));
			});
			globalMaxDi = Math.max(...globalMaxDiArr);
			for(var i = 0; i < spray_date.length; i++){
				var obj = {
					di: maxDis[i],
					spray_date: spray_date[i]
				};
				objData.push(obj);
			}
			newData.push(objData);
			_.forEach(newData, (datas, index) => {
				this.svgOpportunity.append('g')
					.selectAll('dot')
					.data(datas)
					.enter()
					.append('circle')
					.attr('class', 'plot-circle')
					.attr('stroke', (innerDatum) =>{
						return this.colors[0];
					})
					.attr('cx', (innerDatum) => {
						return this.xAxisBottom(this.getMomentDate(this.convertDate(innerDatum.spray_date)).toDate());
					})
					.attr('cy', (innerDatum) => {
						return this.yAxisLeft((globalMaxDi-innerDatum.di)/globalMaxDi * 100);
					})
					.attr('r', (innerDatum) =>{
						return 4;
					})
					.attr('fill', (innerDatum) =>{
						return "#fff";
					})
					.on('mouseover', (innerDatum, innerIndex, nodes) => {
						this.tooltip.style('display', 'block');
						// Have the dots grow
						let circle = d3.select(nodes[innerIndex]);
						circle.attr('r', (innerDatum) =>{
							return 4;
						})
							.attr('cx', () => {
								return this.xAxisBottom(this.getMomentDate(this.convertDate(innerDatum.spray_date)).toDate());
							})
							.attr('cy', () => {
								return this.yAxisLeft((globalMaxDi-innerDatum.di)/globalMaxDi * 100);
							})
							.attr('fill', this.colors[0]);
					})
					.on('mousemove', (innerDatum, innerIndex, nodes) => {
						let value = toInteger((globalMaxDi-innerDatum.di)/globalMaxDi * 100);
						let date = this.getMomentDate(this.convertDate(innerDatum.spray_date)).toDate();
						this.tooltip.html(`<div class="${CLS}-chart-tooltip-date">${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}</div><div class="${CLS}-chart-tooltip-value" style="display:none">${value}%</div>`);
						let tooltipWidth = this.$tooltip.outerWidth();
						let tooltipHeight = this.$tooltip.outerHeight();
						let topPositionOffset = 30;
						// Subtract the left margin alongside half of the tooltip width. This horizontally centers the tooltip
						let leftPosition = (d3.mouse(nodes[innerIndex])[0] + this.margin.left) - 40;
						let topPosition = ((d3.mouse(nodes[innerIndex])[1]) + this.margin.top) - 20 - topPositionOffset;
						
						this.tooltip.style('left', `${leftPosition}px`)
							.style('top', `${topPosition}px`);
					})
					.on('mouseleave', (innerDatum, innerIndex, nodes) => {
						this.tooltip.style('display', 'none');
						// Revert the dot size
						let circle = d3.select(nodes[innerIndex]);
						circle.attr('r', (innerDatum) =>{
							return 4;
						})
							.attr('cx', () => {
								return this.xAxisBottom(this.getMomentDate(this.convertDate(innerDatum.spray_date)).toDate());
							})
							.attr('cy', () => {
								return this.yAxisLeft((globalMaxDi-innerDatum.di)/globalMaxDi * 100);
							})
							.attr('fill', (innerDatum) =>{
								return "#fff";
							});
					})
					.on('click',(innerDatum, innerIndex, nodes) =>{
						this.tooltip.style('display', 'none');
						let value = innerDatum.spray_date;
						let spray_dates_duplicate = [];
						let spray_dates = [];
						let spray_date = 0;
						_.forEach(this.data, (datum) => {
							_.forEach(datum.sims, (value) => {
								_.forEach(value, (sprayDate) => {
									spray_dates_duplicate.push(sprayDate.spray_date);
								});
							});
						});
						spray_dates_duplicate.forEach(element => {
							if (!spray_dates.includes(element)) {
								spray_dates.push(element);
							}
						});
							spray_date = (spray_dates.indexOf(parseInt(value)));
								this.sprayDateInNum = this.sprayDatesArr[spray_date];			
								this.drawOpportunity(spray_date);
								this.drawDiapause(spray_date);
								this.drawRecovery(spray_date);
					})
			});
	}

	// For mite population recovery following control chart
	drawLabels() {
		var labels = [];
		labels.push( {label: " Mites ",} ,{label: " Winter eggs ",}, {label: " Mites with diapause eggs",});
		let textItemWidth = 50;
		let textItemHeight = 30;
		let lineWidth = 20;
		let marginSpacer = 15;
		let legendItemWidth = textItemWidth + lineWidth + marginSpacer + marginSpacer;
		let legendItemOffset = lineWidth + 5; // Relative to the line
		let topPosition = this.height + this.margin.top + this.margin.bottom;
		let dataLength = labels.length;
		let leftPosition = 0;
		// Recallibrate left position when there is an overflow of items
		if(leftPosition < 0) {
			leftPosition = -(marginSpacer * 4);
		}
		// Assign the max amount of legend items that can fit in a column
		let legendItemMaxColumns = 0;
		let xAxisWidth = $('.x-axis')[0].getBoundingClientRect().width;
		for(let index = 0; index < dataLength; index++) {
			if(index * legendItemWidth > (xAxisWidth - (marginSpacer * 3))) {
				legendItemMaxColumns = index - 1;
				break;
			}
		}
		let legendItemRowIndex = 0;

		let legendGroup = this.svgRecovery.append('g').attr('class', 'legend')
		.attr('transform', `translate(${leftPosition}, ${topPosition})`);
			let adjustSvgHeight = () => {
				let svgHeight = this.$element.find('svg').attr('height');
				this.$element.find('svg').attr('height', parseInt(svgHeight) + marginSpacer + textItemHeight);
			};
		adjustSvgHeight();
		_.forEach(labels, (datum, index) => {
			if(index % legendItemMaxColumns === 0 && index !== 0) {
				legendItemRowIndex++;
			}
			let legendItemX = () => {
				if(legendItemMaxColumns !== 0) {
					return (index % legendItemMaxColumns) * legendItemWidth;
				}
				return index * legendItemWidth;
			};
			let legendItemY= () => {
				return legendItemRowIndex * textItemHeight;
			};
			let legendItem = legendGroup.append('g')
				.attr('class', 'legend-item')
				.attr('transform', `translate(${legendItemX()}, ${legendItemY()})`);
			legendItem.append('line')
				.attr('y1', -4)
				.attr('y2', -4)
				.attr('x2', lineWidth)
				.attr('stroke', this.colors[index+1])
				.attr('stroke-width', 8);

			let textElement = legendItem.append('text').html(datum.label);
			this.textWrap(textElement, textItemWidth, legendItemOffset, 0);
		});
	}

	// Creates an inner tspan element for the text element and clips the text
	textWrap(textElement, maxWidth, x, y) {
		let words = textElement.text();
		let tspan = textElement.text(null).append('tspan').text(words).attr('x', x).attr('y', y);

		let textLength = tspan.node().getComputedTextLength();
		let text = tspan.text();
		while(textLength > maxWidth && text.length > 0) {
			text = text.slice(0, -1);
			tspan.text(text + '…');
			textLength = tspan.node().getComputedTextLength();
		}
	}

	// Gets an appropriate tick interval depending on the range
	getLinearTick(range, power = 0, tickCount = 20) {
		if(range !== 0) {
			let intervals = [0.1, 0.2, 0.5, 1, 2, 5];
			for(let i = 0; i < intervals.length; i++) {
				if((range / (intervals[i] * Math.pow(10, power))) > tickCount) {
					continue;
				}
				else {
					return intervals[i] * Math.pow(10, power);
				}
			}
			power += 1;
			return this.getLinearTick(range, power, tickCount);
		}
		return 1;
	}

	printChart(){
		$(this.$printBtn).on('click', (event) => {
			var opportunity = $('.opportunity-container').html(); 
			var diapause = $('.diapause-container').html(); 
			var recovery = $('.recovery-container').html(); 
			var logos = $('.logos').html(); 
			var description = $('.description').html(); 
            var a = window.open('', '', 'height=1800, width=2000'); 
            a.document.write('<html>'); 
			a.document.write('<body style="font-family:din-2014, sans-serif">'); 
			a.document.write('<p><b>TIMERITE® was developed and funded by AWI and CSIRO. Updates and improvements were made by Cesar Australia and CSIRO, with funding from AWI, GRDC, MLA and Cesar Australia.</b></p>');
			a.document.write(logos); 
			a.document.write(opportunity); 
			a.document.write('<table><tr><td width=1000>');
            a.document.write(diapause); 
			a.document.write('</td><td width=1000>'); 
			a.document.write(recovery); 
			a.document.write('</td></tr></table>'); 
			a.document.write(description); 
            a.document.write('</body></html>'); 
            a.document.close(); 
            a.print(); 
		});
	}
}
